import { createFileRoute } from "@tanstack/react-router";
import { TipsPage } from "./tips";

export const Route = createFileRoute("/es/consejos")({
  head: () => ({
    meta: [
      { title: "Consejos para vender tus cosas más rápido | Sellavo" },
      { name: "description", content: "Consejos prácticos para que tu anuncio venda antes: fotos, precio, texto y momento." },
      { property: "og:title", content: "Consejos para vender tus cosas más rápido | Sellavo" },
      { property: "og:description", content: "Consejos prácticos para que tu anuncio venda antes: fotos, precio, texto y momento." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/consejos" }],
  }),
  component: TipsPage,
});
